import { action, makeObservable, onBecomeObserved } from "mobx"

import { catchErrors, checkoutsApi } from "@src/shared/api"
import { CheckoutResponse, Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

class CheckoutsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<CheckoutResponse>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(req: { page: number }) {
    const { page = 0 } = req

    try {
      const {
        data: { data: { data: items, pagination } = {} },
      } = await checkoutsApi.getCheckouts(
        this.order,
        this.calcOffset(page),
        this.pageSize,
      )

      return {
        data: items as CheckoutResponse[],
        pagination: pagination as Pagination,
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }
}

export default CheckoutsCollection
